import { useClientSideTableFilter } from "~components/DataTable/hooks/useClientSideTableFilter.ts";
import type { ClientSideTableSearchField } from "~components/DataTable/types/clientSideTableSearchField.ts";
import { filterByTableField } from "~components/DataTable/utils/filterByTableField.ts";
import { LeagueTableColumns } from "~pages/Leagues/LeagueListPage/enums/leagueTableColumns.ts";
import { LeagueTableFilters } from "~pages/Leagues/LeagueListPage/enums/leagueTableFilters.ts";
import type { League } from "~types/league.ts";

const leagueSearchFields: Array<ClientSideTableSearchField<League>> = [LeagueTableColumns.NameLocal];

const leagueFilterFunctions = {
  [LeagueTableFilters.RegionType]: filterByTableField<League>(LeagueTableColumns.RegionType),
  [LeagueTableFilters.CountryCode]: filterByTableField<League>(LeagueTableColumns.CountryCode),
};

type Props = {
  leagues: Array<League>;
  currentFilter: Record<string, unknown>;
  searchText?: string;
};

export const useFilteredLeagues = ({ currentFilter, leagues, searchText }: Props) => {
  return useClientSideTableFilter({
    data: leagues,
    currentFilter,
    filterFunctions: leagueFilterFunctions,
    searchText,
    searchFields: leagueSearchFields,
  }).filteredData;
};
